//金融机构赛道奖项
export const orgAward = [
  {
    rank: "第1名",
    award: "100000U豆"
  },
  {
    rank: "第2-10名",
    award: "20000U豆"
  },
  {
    rank: "第11-30名",
    award: "10000U豆"
  },
  {
    rank: "第31-50名",
    award: "2000U豆"
  },
  {
    rank: "第51-100名",
    award: "1000U豆"
  },
  {
    rank: "第101-200名",
    award: "888U豆"
  },
  {
    rank: "第201-1000名",
    award: "500U豆"
  },
  {
    rank: "第1001-2000名",
    award: "300U豆"
  },
  {
    rank: "第2001-3000名",
    award: "200U豆"
  }
];

//恒生电子赛道奖项
export const innerAward = [
  {
    rank: "第1名",
    award: "100000U豆"
  },
  {
    rank: "第2-10名",
    award: "20000U豆"
  },
  {
    rank: "第11-20名",
    award: "10000U豆"
  },
  {
    rank: "第21-30名",
    award: "2000U豆"
  },
  {
    rank: "第31-50名",
    award: "1000U豆"
  },
  {
    rank: "第51-1000名",
    award: "500U豆"
  },
  {
    rank: "第1001-2000名",
    award: "200U豆"
  },
  {
    rank: "第2001-3000名",
    award: "100U豆"
  }
];
// export const personalRule = [
//   "1、根据学习热度由高到低每5分钟更新排名；",
//   "2、学习热度：本年度APP学习天数*25%+本年度PC学习天数*15%+本年度视频观看量（每个视频计一次，单视频学习时长需≥5分钟）*60%；",
//   "3、学习热度相同时，则按本年度首次观看视频的先后顺序排列。"
// ];

export const giftList = [
  {
    img: require("../../../assets/activity/learningStar/gift1.png"),
    name: "筋膜枪",
    desc: "1-3名"
  },
  {
    img: require("../../../assets/activity/learningStar/gift2.png"),
    name: "2000U豆",
    desc: "≥4名"
  }
];
export const inviteGift = [
  {
    name: "10积分兑换5000U豆",
    desc: "共100份，先到先得。",
    total:"100"
  },
  {
    name: "20积分兑换花王眼罩一盒",
    desc: "共25份，先到先得。",
    total:"25"
  },
  {
    name: "50积分兑换萌趣大肚杯一个",
    desc: "共10份，先到先得。",
    total:"10"
  },
  {
    name: "100积分兑换筋膜枪一个",
    desc: "共10份，先到先得。",
    total:"10"
  },
]
 


// WEBPACK FOOTER //
// ./src/gtn/views/activities/learningStar/config.js